import { createAsyncThunk } from '@reduxjs/toolkit';
import assetServiceApiInstance from '../../../../config/assetApiConfig';
import { AssetRequest } from './assetRequestTypes';

// Create Asset Request
export const createAssetRequest = createAsyncThunk(
  'assetRequest/create',
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await assetServiceApiInstance.post('/asset-request', data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create asset request');
    }
  }
);

// Fetch All Asset Requests
export const fetchAllAssetRequests = createAsyncThunk(
  'assetRequest/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await assetServiceApiInstance.get('/asset-request');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch asset requests');
    }
  }
);

// Fetch Asset Request by ID
export const fetchAssetRequestById = createAsyncThunk(
  'assetRequest/fetchById',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await assetServiceApiInstance.get(`/asset-request/${id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch asset request');
    }
  }
);

// Update Asset Request
export const updateAssetRequest = createAsyncThunk(
  'assetRequest/update',
  async ({ id, data }: { id: number; data: any }, { rejectWithValue }) => {
    try {
      const response = await assetServiceApiInstance.put(`/asset-request/${id}`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update asset request');
    }
  }
);

// Delete Asset Request
export const deleteAssetRequest = createAsyncThunk(
  'assetRequest/delete',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await assetServiceApiInstance.delete(`/asset-request/${id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to delete asset request');
    }
  },
);
// Fetch Asset Requests by Employee ID
export const fetchAssetRequestsByEmployeeId = createAsyncThunk(
  'assetRequest/fetchByEmployeeId',
  async (employeeId: number, { rejectWithValue }) => {
    try {
      const response = await assetServiceApiInstance.get(`/asset-request/employee/${employeeId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch asset requests by employee');
    }
  }
);
